'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _systemIngredientForm = require('./system-ingredient-form.component');

var _systemIngredientForm2 = _interopRequireDefault(_systemIngredientForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.admin.system-ingredients.system-ingredient-form', []).component('systemIngredientForm', _systemIngredientForm2.default).name;


// WEBPACK FOOTER //
// ./components/app/admin/system-ingredients/system-ingredient-form/system-ingredient-form.module.js